module.exports = __webpack_public_path__ + "media/נ.3308070c.mp3";